export default __webpack_public_path__ + "static/media/main.80f380fa.jpg";